import lazyLoading from './lazyLoading'

export default {
  path: '/projects/basic',
  component: lazyLoading('projects', true),
  meta: {
    auth: true,
    label: 'Basic Projects',
    expanded: false,
    icon: 'folder',
  },
  children: [
    {
      path: '/projects/basic',
      name: 'BasicProjects',
      hidden: true,
      meta: {
        label: '',
      },
      component: lazyLoading('projects/ProjectList')
    }, {
      name: 'NewBasicProject',
      path: '/projects/basic/new',
      hidden: true,
      meta: {
        label: 'New',
      },
      component: lazyLoading('projects/CreateForm'),
    }, {
      name: 'EditBasicProject',
      path: '/projects/basic/:id/edit',
      hidden: true,
      meta: {
        label: '',
      },
      component: lazyLoading('projects/Edit'),
      props: true
    }]
}
